import { makeAutoObservable } from 'mobx';
import { socketStore } from '../../socket.store';
import { IReceivedMsg } from '../../modules/scenetemplate/hooks/constants';

export type TMessage = { user: string; message: string; date: Date };
class ChatStore {
  showChat: boolean = false;
  messageList: { [key: string]: IReceivedMsg[] } = {};
  companion: any = null;
  unreadMessages: { [key: string]: number } = {};
  showRoomUsers: boolean = true;

  constructor() {
    makeAutoObservable(this);
  }

  get renderList() {
    return this.messageList[this.companion?.id] || [];
  }

  setShowChat = (state: boolean, id: string | number = '') => {
    this.showChat = state;
  };

  setMessageList = (id: string, msg: IReceivedMsg) => {
    const state = this.messageList[id] || [];
    this.messageList = { 
      ...this.messageList,
      [id]: [...state, msg],
    };
    this.incrementUnreadMessages(id);
  };

  setExistMsg = (data: any) => {
    console.log(data);
    
    this.messageList = data
  }

  setGlobalMsg = (msg: IReceivedMsg) => {
    const state = this.messageList['global'] || [];
    this.messageList = { ...this.messageList, global: [...state, msg] };
  };

  incrementUnreadMessages = (id: string) => {
    this.unreadMessages = {
      ...this.unreadMessages,
      [id]: ++this.unreadMessages[id] || 1,
    };
  };

  getAllUnreadMessagesCount = (id: string = "") => {
    if(id) {
      return this.unreadMessages[id]
    }
    return Object.values(this.unreadMessages).reduce((acc: number, val: number) => acc + val, 0);
  };

  clearUnreadMessages = (companion: any) => {
    if(companion) {
      delete this.unreadMessages[companion.id];
    } else {
      this.unreadMessages = {};
    }
  };

  setCompanion = (companion: any) => {
    this.companion = companion;
    this.showRoomUsers = false;
    if(companion) {
      delete this.unreadMessages[companion.id];
    }
  };

  getSocketUser = (userId: number) => {
    const { dashboardState } = socketStore;
    return {
      id: dashboardState[userId].id,
      image: dashboardState[userId].readyPlayerMeAvatarImage,
    };
  };

  showAllUsers = (bool: boolean) => {
    this.showRoomUsers = bool;
    this.companion = null;
  };
}

export const chatStore = new ChatStore();
